import { Component, ViewChild, AfterViewInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi, GridOptions } from 'ag-grid-community';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/utils/shared.service';
import { BehaviorSubject } from 'rxjs';
import { Parameter } from 'src/app/common/grid-utils/parameter.model';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';
import { ExamType } from './exam-type.model';
import * as CommonConstants from '../../utils/common.constants';
@Component({
  selector: 'app-add-exams',
  templateUrl: './add-exams.component.html'
})
export class AddExamsComponent implements AfterViewInit {

  gridApi: GridApi;
  prList = [];
  rowData = [];
  status;
  @Input() medFileId;
  //add medication 
  colDefs;
  examType$ = new BehaviorSubject<any>(null);
  examTypes;
  frameworkComponents;
  gridOptions: GridOptions;
  //IS,ES,EB
  selectedExamType;
  specExams = [];
  imgExams = [];
  bioExams = [];
  PARAM_KEY = [CommonConstants.STATUS];
  partnerList = [];
  hospitalList = [];
  specialistList = [];
  ptype = [CommonConstants.PARTNER_HOSPITAL_TYPE, CommonConstants.PARTNER_PRACTITIONER_TYPE];
  MED_PARAM_KEY = [CommonConstants.EXAMINATION_MED_FILE];
  
  constructor(private modal: NgbModal, private masterService: MasterService, private sharedService: SharedService,
    private medFileService: MedicalFileService, private toastrService: ToastrService) {
    this.frameworkComponents = {
      ngSelectEditor: GridNgSelectDataComponent,
      agDateInput: CustomDateComponent
    }
    this.gridOptions = <GridOptions>{
      stopEditingWhenGridLosesFocus: true
    };
  }

  ngOnInit() {
    if (!this.examType$.value) {
      this.masterService.getExamType().subscribe(res => {
        if (res && res["result"]) {
          this.examType$.next(res["result"]);
          this.setExamTypes();
        }
      })
    } else {
      this.setExamTypes();
    }

    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        let masterValues = response['result'];
        this.status = masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
      }
    });

    this.masterService.getPartnersByPartnerType(this.ptype);
    this.masterService.partnerList.subscribe(value => {
      this.partnerList = value;
      this.filterPartnerTypes();
    });

    this.sharedService.medicalFileId$.subscribe(res => {
      this.medFileId = res;
    })
    this.loadExaminations();
  }

  loadExaminations() {
    this.sharedService.medicalFileId$.subscribe(res => {
      this.medFileId = res;
      this.medFileService.getMedicalFilesByKey(this.medFileId, this.MED_PARAM_KEY).subscribe(response => {
        let masterValues = response['result'];
        if (masterValues) {
          let examMasterList = masterValues[CommonConstants.EXAMINATION_MED_FILE];
          this.specExams = this.setExamList(examMasterList.filter(item => item.cutypCode === CommonConstants.SPEC_EXAMINATION_TYPE_ID));
          this.bioExams = this.setExamList(examMasterList.filter(item => item.cutypCode === CommonConstants.BIO_EXAMINATION_TYPE_ID));
          this.imgExams = this.setExamList(examMasterList.filter(item => item.cutypCode === CommonConstants.IMG_EXAMINATION_TYPE_ID));
        }
      })
    })
  }

  filterPartnerTypes() {
    if (!this.partnerList) {
      this.masterService.getPartnersByPartnerType(this.ptype);
      this.masterService.partnerList.subscribe(value => {
        this.partnerList = value;
        this.setPartners();
      })
    } else {
      this.setPartners();
    }

  }
  setPartners() {
    if (this.partnerList) {
      this.hospitalList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_HOSPITAL_TYPE);
      this.specialistList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_PRACTITIONER_TYPE);
    }
  }

  defaultColDef = {
    editable: true,
    singleClickEdit: true
  }

  ngAfterViewInit() {
  }



  setExamTypes() {
    this.examType$.subscribe(res => {
      this.examTypes = res;
    })
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  openGridModal(modalId, examType) {
    this.modal.open(modalId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.selectedExamType = examType;
    let filterExamType = this.examTypes.filter(obj => obj.cutypCode === examType
    );
    this.getGrids(filterExamType);
  }

  addNewGridRow() {
    const newRow = {
      hospType: '',
      extypId: '',
      extypDescEn: '',
      examType: { "extypId": null, "extypDescEn": null },
      medprDtDate: '', medprDtPrescription: '', medprNuDurationInDay: '', medmeNuQtyPerTake: '', medprVaName: '',
      medprVaOperator: '', statuCode: ''
    };
    this.rowData.push(newRow);
    this.gridApi.setRowData(this.rowData);
  }

  getGrids(examTypes) {
    this.rowData = [];
    this.colDefs = [
      { headerName: 'Code', field: 'medcuVaCode'},
      { headerName: 'extypId', field: 'extypId', hide: true },
      {
        headerName: 'Type', field: 'extypDescEn', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: examTypes, dataColumn: 'extypId', model: new ExamType(), objectData: ['extypId', 'extypDescEn'] }
      },
      { headerName: 'Description', field: 'medcuVaDesc' },
      { headerName: 'Date', field: 'medcuDtDate', cellEditor: 'agDateInput' },
      { headerName: 'hospiId', field: 'hospiId', hide: true },
      {
        headerName: 'Hospital', field: 'hospital', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.hospitalList, dataColumn: 'hospiId', model: new Parameter(), objectData: ['partnerid', 'partnername'] }
      },
      { headerName: 'prtieId', field: 'prtieId', hide: true },
      {
        headerName: 'Physician', field: 'specialist', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.specialistList, dataColumn: 'prtieId', model: new Parameter(), objectData: ['partnerid', 'partnername'] }
      },
      { headerName: 'Conclusion', field: 'medcuVaConclusion' },
      { headerName: 'statuCode', field: 'statuCode', hide: true },
      {
        headerName: 'Result', field: 'statuCode', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['statusId', 'description'] }
      }
      /*   { headerName: 'statuCode', field: 'statuCode', hide: true },
        {
          headerName: 'Status', field: 'status', cellEditor: 'ngSelectEditor',
          cellEditorParams: { values: status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['statusId', 'description'] }
        }, */
    ];
  }

  saveExam() {
    this.rowData = this.rowData.map(item => ({
      ...item,
      medfiId: this.medFileId,
      cutypCode: this.selectedExamType
    }));
    this.medFileService.saveExaminations(this.rowData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Saved Succesffully");
        if (res["result"][0]) {
          switch (this.selectedExamType) {
            case "EB":
              this.bioExams.push(this.setExamList(res["result"][0]));
              this.bioExams = Object.values(this.bioExams.reduce((acc, c) => (acc[c.medcuId] = c, acc), {}));
              this.bioExams = [...this.bioExams];
              break;
            case "ES":
              this.specExams.push(this.setExamList(res["result"][0]));
              this.specExams = Object.values(this.specExams.reduce((acc, c) => (acc[c.medcuId] = c, acc), {}));
              this.specExams = [...this.specExams];
              break;
            case "IS":
              this.imgExams.push(this.setExamList(res["result"][0]));
              this.imgExams = Object.values(this.imgExams.reduce((acc, c) => (acc[c.medcuId] = c, acc), {}));
              this.imgExams = [...this.imgExams];
              break;
          }
        }

        this.modal.dismissAll();
      }
    })
  }

  onRowSelect(modelId, examType) {
    let filterExamType = this.examTypes.filter(obj => obj.cutypCode === examType);
    this.getGrids(filterExamType);
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    switch (examType) {
      case "EB":
      this.rowData =  this.bioExams;
        break;
      case "ES":
        this.rowData =  this.specExams;
        break;
      case "IS":
        this.rowData =  this.imgExams;
        break;
    }
  }

  setExamList(list) {
    if (Array.isArray(list)) {
      list = list.map(item => ({
        ...item,
        /*  status: item.statuCode ? this.status.find(obj => +obj.id === +item.statuCode).value : null, */
        extypDescEn: item.extypId ? this.examTypes.find(obj => obj.extypId === item.extypId).extypDescEn : null,
        specialist: item.prtieId ? this.specialistList.find(obj => obj.partnerid === item.prtieId).partnername : null,
        hospital: item.hospiId ? this.hospitalList.find(obj => obj.partnerid === item.hospiId).partnername : null,
      }));
    } else {
      list = {
        ...list,
        extypDescEn: list['extypId'] ? this.examTypes.find(obj => +obj.extypId === +list['extypId']).extypDescEn : null,
        specialist: list['prtieId'] ? this.specialistList.find(obj => +obj.partnerid === +list['prtieId']).partnername : null,
        hospital: list['hospiId'] ? this.hospitalList.find(obj => +obj.partnerid === +list['hospiId']).partnername : null
      };
    }
    return list;
  }
}
